import emojiData from 'unicode-emoji-json';

const normalizeName = (name: string) => (/:.+:/.test(name) ? name.slice(1, -1) : name);
const translateEmojiName = (name: string) => {
  switch (name) {
    case 'thumbsup':
      return 'thumbs_up';
    case 'thumbsdown':
      return 'thumbs_down';
    case 'heart':
      return 'red_heart';
    default:
      return name;
  }
};

export const useEmoji = () => {
  const findByName = (name: string): string => {
    const normalizedName = translateEmojiName(normalizeName(name));

    for (const emoji in emojiData) {
      if (emojiData[emoji].slug === normalizedName) {
        return emoji;
      }
    }

    return '';
  };

  return { findByName };
};
